<template>
    <v-container>
          <v-col class="text-center" cols="12">
            <h1>Welcome to {{ title }}</h1>
          </v-col>
      
    </v-container>
</template>

<script setup>
  import { ref } from 'vue'
  
  var title = ref(process.env.VUE_APP_TITLE)
</script>
